import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class TransactionService {

  constructor(private http: HttpClient,
    private logger: NGXLogger) { }

  getTransLogsView(transObj): any {
    //this.logger.debug("calling get api from service .....");
    return this.http.post('/honcho/api/logs/transaction',transObj , { observe: 'response' });
  }
}



// WEBPACK FOOTER //
// ./src/app/logs/transaction-logs/transaction.service.ts